class SpillToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-spill-toggle]');
    if (!this.button) return;

    this.kvmInput = document.querySelector('#s-feet');
    this.qtyInput = document.querySelector('input[name="quantity"]');

    this.active = this.dataset.defaultOn !== 'false';
    this.updateButtonState();

    this.button.addEventListener('click', () => {
      this.active = !this.active;
      this.updateButtonState();
      this.recompute();
    });

    if (this.kvmInput) {
      this.kvmInput.addEventListener('input', () => {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.recompute(), 30);
      });

      // On variant change the calculator resets m² and lådor without firing events, and writes
      // data-vpu last. Re-apply spill once it has, so the toggle and lådor never disagree.
      this._vpuObserver = new MutationObserver(() => this.recompute());
      this._vpuObserver.observe(this.kvmInput, { attributes: true, attributeFilter: ['data-vpu'] });
    }
  }

  disconnectedCallback() {
    clearTimeout(this._timer);
    if (this._vpuObserver) this._vpuObserver.disconnect();
  }

  updateButtonState() {
    this.button.setAttribute('aria-pressed', this.active ? 'true' : 'false');
    this.button.classList.toggle('is-active', this.active);
  }

  recompute() {
    if (!this.kvmInput || !this.qtyInput) return;

    const kvm = parseFloat(this.kvmInput.value) || 0;
    if (kvm <= 0) return;

    const vpu = parseFloat(this.kvmInput.dataset.vpu) || 0;
    if (!vpu) return;

    const baseBoxes = Math.max(1, Math.ceil(kvm / vpu));
    // toFixed strips float noise first: 100 × 1.1 is 110.00000000000001 in JS, which would add a box.
    const targetBoxes = this.active
      ? Math.max(1, Math.ceil(Number(((kvm * 1.1) / vpu).toFixed(6))))
      : baseBoxes;

    if (parseInt(this.qtyInput.value, 10) === targetBoxes) return;

    // No input/change here: the calculator treats those as the customer editing lådor and
    // rewrites the m² field to lådor × vpu, which garbled typing and compounded the 10%.
    this.qtyInput.value = targetBoxes;
    this.qtyInput.dispatchEvent(new CustomEvent('quantity:update', { bubbles: true }));
  }
}

if (!customElements.get('spill-toggle')) {
  customElements.define('spill-toggle', SpillToggle);
}
